import DataSourceFormDialog from './data-source-form-dialog'
import i18n from 'scoreboard/components/i18n'
import ColumnForm from './column-form'

var ColumnFormDialog = DataSourceFormDialog.extend({

	/**
	 * @override
	 */
	formConstructor: ColumnForm,

	/**
	 * @override
	 */
	context: function() {
		let title = this.options.edit ?
			i18n.get('common.edit2', 'datasets.column') :
			i18n.get('datasets.choose.columns.newTitle')
		return { title }
	}

})

export default ColumnFormDialog

ColumnFormDialog.__filename__ = 'datasets/column-form-dialog.js'
